import useUploadImage from "../../../../hooks/useUploadImage";
import { RegistroIngresoSessionContext } from "../../../../views/LogisticPark/RegistroIngreso/session/RegistroIngresoSessionContext";
import { useContext } from "react";

export const useImage = () => {
  const { uploadImgEvent, uploadNewPhoto } = useUploadImage();
  const sessionContext = useContext(RegistroIngresoSessionContext);

  const activeTab = sessionContext?.tabs?.find(
    (tab: any) => tab.id === sessionContext?.activeTabId
  );
  const currentEventId = activeTab?.values?.eventId;
  const currentUserId = activeTab?.values?.id;

  const USER_FILE_TYPES = ["facePhoto", "frontDNI", "backDNI", "frontDriverLicense"];

  const uploadImage = (name: string, file: File, dataUrl: string) => {
    if (name.startsWith("companions.")) {
      // Companion images are uploaded upon form submission in useEvent.ts,
      // since the companion user and event IDs are not resolved yet.
      return;
    }

    let sdkField = name;
    if (name === "visitorPhoto") sdkField = "facePhoto";

    const isUserFile = USER_FILE_TYPES.includes(sdkField);
    if (isUserFile && currentUserId) {
      uploadNewPhoto(dataUrl, sdkField, file.name, true, currentUserId, currentEventId!);
    } else {
      uploadImgEvent(dataUrl, sdkField, file.name, currentEventId!);
    }
  };

  return { uploadImage, USER_FILE_TYPES };
};

export default useImage;
